import { Fragment } from 'react';
import PropTypes from 'prop-types';

import MainNavigation from './MainNavigation';

const Layout = (props) => {
  return (
    <Fragment>
      <MainNavigation />
      <main>{props.children}</main>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any
};

export default Layout;
